import React from "react";
import { Card, Banner } from "@shopify/polaris";
import { Col } from "reactstrap";
import { useSelector } from "react-redux";
import config from "../../config/config";
const Step = () => {
  const listAccount = useSelector((state) => state.listPayPalAccounts);
  return (
    <Col className="privacy d-flex" xs="12" lg="12" sm="12" xl="4">
      <Card title="Step by step video to connect to your account" sectioned>
        <div>
          <div className="mt-4">
            <iframe
              src="https://www.youtube.com/embed/939S7HqgJi4"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Video Tutorial"
              width="100%"
              height="300"
            />
          </div>
          <Banner status="default">
            <p
              className="text-left"
              style={{ lineHeight: "26px", fontSize: "15px" }}
            >
              We only require <b>minimal access </b> from your account to add
              tracking info to Paypal. Rest assured that your account will{" "}
              <b>always be safe</b>
            </p>
          </Banner>
          <div>
            {listAccount.length > 1 ? (
              <div className="mt-4">
                <Banner status="info" title="Note">
                  <p>
                    {" "}
                    - Orders that do not have the PayPal accounts received from{" "}
                    {config.platform === "WOO_COMMERCE"
                      ? "WooCommerce"
                      : "Shopify"}
                    , the tracking information will be added to the{" "}
                    <b>primary account.</b>
                    <br /> -The order will be marked as{" "}
                    <b>"Missing PayPal account"</b> in case it has PayPal
                    account received from{" "}
                    {config.platform === "WOO_COMMERCE"
                      ? "WooCommerce"
                      : "Shopify"}{" "}
                    but does not match any PayPal account already connected to
                    the app.
                  </p>
                </Banner>
              </div>
            ) : null}
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default Step;
